import { render, staticRenderFns } from "./AdminDropdownValueList.vue?vue&type=template&id=4433dbe2&scoped=true"
import script from "./AdminDropdownValueList.vue?vue&type=script&lang=js"
export * from "./AdminDropdownValueList.vue?vue&type=script&lang=js"
import style0 from "./AdminDropdownValueList.vue?vue&type=style&index=0&id=4433dbe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4433dbe2",
  null
  
)

export default component.exports